import React from "react";
import api from "../../../Api/apiAxios";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Button, Col, FloatingLabel, ListGroup, Row } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import Loading from "../../../Components/Loading";
import styles from "./ViewPersonalizacaoPonto.module.css";
import { Container, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { format } from "date-fns";
import { FormSectionBox } from "../../Pedidos/styles";
import { StyledTableCell } from "../../Pedidos/components/acesso/acessoIndex";

const ViewPersonalizacaoPonto = () => {
    const { id } = useParams();

    const navigate = useNavigate();    

    const [loading, setLoading] = React.useState(false);
    const [registro, setRegistro] = React.useState({});
    const [dataValidade, setDataValidade] = React.useState('');
    const [dataPedido, setDataPedido] = React.useState('');    
    const [dataLiberacao, setDataLiberacao] = React.useState(''); 
    const [cnpjs, setCnpjs] = React.useState([]);
    const [dataCancelamentoContrato, setDataCancelamentoContrato] = React.useState('');
    const [ultimoValorContrato, setUltimoValorContrato] = React.useState(0);
    const [negociacoes, setNegociacoes] = React.useState([]);
    const [contratoId, setContratoId] = React.useState(null);
    const [observacoesPedido, setObservacoesPedido] = React.useState('* * * * * *');

    const getModalidadeConfig = (tipoInstalacao) => {
        const config = {
          0: {
            tipoComercializacao: 1,
            tipoServicoPedido: 1,
            tipoPlano: 1,
            tipoLicenciamento: 2,
            plano: tipoInstalacao,
          },
          1: {
            tipoComercializacao: 2,
            tipoServicoPedido: 2,
            tipoPlano: 1,
            plano: tipoInstalacao,
          },
          2: {
            tipoComercializacao: 2,
            tipoServicoPedido: 2,
            tipoPlano: 2,
            plano: tipoInstalacao,
          },
        };
    
        return config[tipoInstalacao];
      };

    React.useEffect(() => {
        (async () => {
            setLoading(true);
            try {   
                const tipo = "ID";
                const response = await api.get(`/LicencaPonto/${tipo}/${id}`);    

                if (response.data.tipoComercializacao === null && response.data.tipoInstalacao !== undefined) {
                    const config = getModalidadeConfig(response.data.tipoInstalacao);
                    response.data = {
                        ...response.data,
                        ...config,
                    };
                }

                if   (response.data.dataValidade) {                    
                     var data = response.data.dataValidade.toString();
                     var ano = data.substr(0,4);
                     var mes = data.substr(5,2);
                     var dia = data.substr(8,2);                  
                     setDataValidade(dia + "/" + mes + "/" + ano);            
                }
                else (response.data.tipoComercializacao === 1) ? setDataValidade("Cópia Vitalicia!") : setDataValidade('* * * * * *');                     
                    
                if (response.data.dataRegistro !== null) {
                    const dataRegistroString = response.data.dataRegistro.substring(8,10) + "/" +
                                               response.data.dataRegistro.substring(5,7)  + "/" +   
                                               response.data.dataRegistro.substring(0,4);
                    response.data.dataRegistro = dataRegistroString;
                }
                else response.data.dataRegistro = '* * * * * *';

                const resp = await api.get(`/ClienteCnpj/${response.data.clienteId}`);
                const registrosFiltrados = resp.data.filter((cnpjAdicional) => 
                      cnpjAdicional.status === 1);          
                setCnpjs(registrosFiltrados);

                if  (response.data.pedidoId > 0) {
                    const resp2 = await api.get(`/BmaPonto/${response.data.pedidoId}`); 

                    const data = resp2.data.dataPedido.substring(8,10) + "/" +
                                 resp2.data.dataPedido.substring(5,7)  + "/" +   
                                 resp2.data.dataPedido.substring(0,4);
                    setDataPedido(data);
                    setObservacoesPedido(resp2.data.observacao || '* * * * * *');

                    if (resp2.data.dataLiberacao !== null) {
                        const data2 = resp2.data.dataLiberacao.substring(8,10) + "/" +
                                      resp2.data.dataLiberacao.substring(5,7)  + "/" +   
                                      resp2.data.dataLiberacao.substring(0,4);
                         setDataLiberacao(data2);
                    }
                    else setDataLiberacao('* * * * * *');
    
                }
                else {
            //        response.data.valorContrato = 0;
                    setDataPedido('* * * * * *');
                    setDataLiberacao('* * * * * *');
                    setObservacoesPedido('* * * * * *');
                }

                const retorno = await api.get(`/Contrato/retornar-situacao-contrato?numeroSerie=${response.data.numeroSerie}`);
                setUltimoValorContrato(retorno.data.valor);
                setContratoId(retorno.data.id);

                if (retorno.data.dataCancelamento !== null) {
                   const dataCancelamento = retorno.data.dataCancelamento.substring(8,10) + "/" +
                                            retorno.data.dataCancelamento.substring(5,7)  + "/" +   
                                            retorno.data.dataCancelamento.substring(0,4);
                     setDataCancelamentoContrato(dataCancelamento);
                }
                else setDataCancelamentoContrato('* * * * * *');
                setRegistro(response.data);
            } catch (error) {
                alert(error);
            } finally {
                setLoading(false);
            }     
        }
        )();

    }, [id]);

    React.useEffect(() => {
        (async () => {
            if (!contratoId) return;
            try {
                const resp = await api.get(`NegociacaoContrato/contrato?idContrato=${contratoId}&tipoSistema=Ponto`);
                if (resp.data && resp.data.length > 0) {
                    const negociacoesOrdenadas = resp.data.sort((a, b) => new Date(b.periodoInicial) - new Date(a.periodoInicial));
                    setNegociacoes(negociacoesOrdenadas);
                }
            } catch (error) {
                console.error('Erro ao buscar negociações:', error);
            }
        })();
    }, [contratoId]);                


    if  (loading) return <Loading />

    return (
        <section className={styles.form}>

            <Alert style={{background: 'ghostwhite', color: 'black'}}>
               <Alert.Heading style={{textAlign: 'center'}}>Licença BmaPonto</Alert.Heading>        
            <br />  

            <Row className="g-2" style={{marginBottom: '1rem'}}>
    
                <Col md='6'>
                     <FloatingLabel controlid="floatingInputGrid4" label="Revenda">
                        <Form.Control value={registro.distribuidor?.razaoSocial} disabled />
                      </FloatingLabel>      
                </Col>                
    
                <Col md='3'>
                     <FloatingLabel controlid="floatingInputGrid5" label="Número de Série">                               
                            <Form.Control value={registro.numeroSerie} disabled />                       
                    </FloatingLabel>      
                </Col>                

                <Col md='3'>
                     <FloatingLabel controlid="floatingInputGrid6" label="Versão">
                            <Form.Control value={registro.versao} disabled />                        
                    </FloatingLabel>      
                </Col>                
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
    
                <Col md='6'>
                    <FloatingLabel controlid="floatingInputGrid2" label="Cliente">
                        <Form.Control value={registro.razaoSocial} disabled />             
                    </FloatingLabel>                  
                </Col>

                <Col md='3'>
                     <FloatingLabel controlid="floatingInputGrid4" label="CNPJ / CPF">
                        <Form.Control value={registro.numeroInscricao} disabled />
                      </FloatingLabel>      
                </Col>                

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid9" label="Banco De Dados">
                        <Form.Select value={registro.tipoBancoDados} disabled>
                            <option value="1">MySql</option>
                            <option value="2">SqlServer</option>
                            <option value="3">Oracle</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md={registro.tipoComercializacao === 1 ? '2' : '4'}>
                    <FloatingLabel controlid="floatingInputGrid7" label="Tipo de Comercialização">
                        <Form.Select value={registro.tipoComercializacao} disabled>
                            <option value="1">Licenciado</option>
                            <option value="2">Locação</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>

                {registro.tipoComercializacao === 1 &&
                    <Col md='2'>
                        <FloatingLabel controlid="floatingInputGrid7" label="Tipo de Licenciamento">
                            <Form.Select value={registro.tipoLicenciamento} disabled>
                                <option value="1">Anual</option>
                                <option value="2">Prazo Indeterminado</option>
                            </Form.Select>
                        </FloatingLabel>                    
                    </Col>
                }

                <Col md='2'>
                    <FloatingLabel controlid="floatingInputGrid7" label="Tipo de Serviço">
                        <Form.Select value={registro.tipoServicoPedido} disabled>
                            <option value="1">On Premisse</option>
                            <option value="2">SaaS</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>

                <Col md='2'>
                    <FloatingLabel controlid="floatingInputGrid7" label="Tipo de Plano">
                        <Form.Select value={registro.tipoPlano} disabled>
                            <option value="1">Rep-C</option>
                            <option value="2">Rep-P</option>
                        </Form.Select>
                    </FloatingLabel>                    
                </Col>

                <Col md='2'>
                    <FloatingLabel controlid="floatingInputGrid6" label="Faixa Funcionários">
                        <Form.Control value={registro.faixaFuncionarios} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='2'>
                    <FloatingLabel controlid="floatingInputGrid11" label="Data Validade">
                        <Form.Control value={dataValidade} disabled />
                    </FloatingLabel>      
                </Col>
            </Row>                    

            <Row className="g-2" style={{marginBottom: '1rem'}}>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid12" label="Data Registro">
                        <Form.Control value={registro.dataRegistro} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid23" label="Data Pedido">
                        <Form.Control value={dataPedido} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid43" label="Data Liberação">
                        <Form.Control value={dataLiberacao} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid12" label="Total Pedido (R$)" style={{fontWeight: 'bold'}}>
                        <Form.Control value={registro.valorPedido} disabled />
                    </FloatingLabel>      
                </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='12'>
                    <FloatingLabel controlid="floatingInputGridObs" label="Observações do Pedido">
                        <Form.Control
                            as="textarea"
                            style={{height: '100px'}}
                            value={observacoesPedido}
                            disabled
                        />
                    </FloatingLabel>
                </Col>
            </Row>

            <Row className="g-2" style={{marginBottom: '1rem'}}>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid14" label="Valor Contrato (R$)" style={{fontWeight: 'bold'}}>                       
                        <Form.Control value={registro.valorContrato} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid52" label="Ultimo Valor Contrato">
                        <Form.Control value={ultimoValorContrato} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid51" label="Contrato Cancelado em">
                        <Form.Control value={dataCancelamentoContrato} 
                                      style={{color: 'tomato'}}  disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid21" label="Total Usuarios">
                        <Form.Control value={registro.quantidadeUsuarios} disabled />
                    </FloatingLabel>      
                </Col>

                <Col md='3'>
                    <FloatingLabel controlid="floatingInputGrid13" label="Token">
                        <Form.Control value={registro.token} disabled />
                    </FloatingLabel>      
                </Col>
            </Row>

            <br /> 
            <hr />                    
            <Alert.Heading style={{textAlign: 'center'}}>Integrações & Módulos Adicionais</Alert.Heading>        
            <br /> 

            <Row className="g-2" style={{marginBottom: '1rem'}}>
                <Col md='2'>
                    <Form.Check 
                        type="switch"
                        id="portaria671"
                        label="Portaria 671"                      
                        readOnly
                        checked={registro.portaria671 === 1}
                    />
                </Col>

                <Col md='2'>
                    <Form.Check 
                        type="switch"
                        id="integradorRep"
                        label="Integrador REP"                      
                        readOnly
                        checked={registro.integradorRep === 1}
                    />
                </Col>

                <Col md='2'>
                    <Form.Check 
                        type="switch"
                        id="epi"
                        label="Módulo EPI"                      
                        readOnly
                        checked={registro.moduloEpi === 1}
                    />
                </Col>

                <Col md='2'>
                    <Form.Check 
                        type="switch"
                        id="integraWacesso"
                        label="BmaAcesso"                      
                        readOnly
                        checked={registro.integracaoAcesso === 1}
                    />
                </Col>

                <Col md='2'>
                    <Form.Check 
                        type="switch"
                        id="integraWge"
                        label="BmaFolha"                      
                        readOnly
                        checked={registro.integracaoFolha === 1}
                    />
                </Col>

                <Col md='2'>
                    <Form.Check 
                        type="switch"
                        id="contrato"
                        label="Contrato"                      
                        readOnly
                        checked={registro.temContrato === 1}
                    />
                </Col>

            </Row>                    

            <br /> 
            <hr />                    
            <Alert.Heading style={{textAlign: 'center'}}>Inscrições Adicionais</Alert.Heading>        
            <br /> 

            {cnpjs.map(cnpj => 
                <ListGroup horizontal  key={cnpj.inscricaoAdicional} className="my-2">
                    <ListGroup.Item variant="secondary" style={{width: "525px", fontWeight: "bold", fontSize: 14}}>{cnpj.razaoSocial}</ListGroup.Item>
                    <ListGroup.Item variant="secondary" style={{width: "200px", fontWeight: "bold", fontSize: 14}}>{cnpj.inscricaoAdicional}</ListGroup.Item>
                </ListGroup>                                                                                        
                    
            )}

            {negociacoes.length > 0 && (
              <>
              <br /> 
              <hr />                    
              <Alert.Heading style={{textAlign: 'center'}}>Negociações do Contrato</Alert.Heading>        
                <FormSectionBox>
                    <Container sx={{ my: 3 }}>
                        <TableContainer component={Paper} sx={{ overflow: 'visible' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Período Inicial</StyledTableCell>
                                        <StyledTableCell>Período Final</StyledTableCell>
                                        <StyledTableCell>Valor Negociado (R$)</StyledTableCell>
                                        <StyledTableCell>Motivo</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {negociacoes.length > 0 ? (
                                        negociacoes.map((row, index) => (
                                            <TableRow key={index}>
                                                <StyledTableCell>{format(new Date(row.periodoInicial), 'dd/MM/yyyy')}</StyledTableCell>
                                                <StyledTableCell>{format(new Date(row.periodoFinal), 'dd/MM/yyyy')}</StyledTableCell>
                                                <StyledTableCell>{row.valorNegociado.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell>{row.descricaoMotivo}</StyledTableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <StyledTableCell colSpan={4} align="center">
                                                Nenhuma negociação encontrada
                                            </StyledTableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                </FormSectionBox>
              </>
            )}

            </Alert>

            <div className={styles.areaBtn}>    
               <Button onClick={() => navigate(-1)} variant="outline-info" className={styles.btn}>Voltar</Button>
            </div>    

        </section>
    )
}

export default ViewPersonalizacaoPonto;
